import { useModal } from '../modal/index.js'
import { useCore } from '../core/index.js'
import { useAnalytics } from '../analytics/index.js'
import fakeDoorImage from '@/assets/images/fake-door.png'

const modal = useModal()

const { close } = modal

const open = async ({
  onClose,
  onCancel,
  title,
  text,
  sendAnalyticsEvent = () => {},
  img = {
    url: fakeDoorImage,
    height: '185px',
  },
  modalOptions = {},
} = {}) => {
  const { t } = useCore()
  const analytics = useAnalytics()

  sendAnalyticsEvent(analytics.EVENT_ACTIONS.VIEW_OPENED)

  return modal.open({
    width: '448px',
    class: 'b-items-stretch md:b-items-start',
    content: {
      $image: img,
      $title: title || t('fake-door.title'),
      $text: text || t('fake-door.description'),
    },
    buttons: [
      {
        $text: t('fake-door.ok'),
        size: 'lg',
        theme: 'primary',
        '@click': () => {
          sendAnalyticsEvent(analytics.EVENT_ACTIONS.PROCEED_CLICKED)
          modal.close()
        },
      },
    ],
    onClose: onClose || (() => {}),
    onCancel: onCancel || (() => {}),
    ...modalOptions,
  })
}

export function useFakeDoor () {
  return { open, close }
}
